module.exports = __webpack_public_path__ + "media/images/gallery/8s-8ec9471e5441c47ab35407cce4ff5b06.jpg";